module.exports = __webpack_public_path__ + "img/Tessellate03.b5ad2068.jpg";